<template>
    <div id="footer" class="footer">

        <footer class="footer-container">
            <div class="content">
                <img alt="MKX logo" v-bind:src="require('@/assets/logo-prov.png')" class="logo">
                <div class="socials">
                    <a v-bind:href="instagram" target="_blank"><i class="fab fa-instagram-square"></i></a>
                    <a v-bind:href="twitter" target="_blank"><i class="fab fa-twitter-square"></i></a>
                </div>
            </div>
            <div class="mentions">
                <p><a href="">{{ mentions }}</a></p>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name:'Footer',
    data () {
        return {
            instagram: "https://www.instagram.com/magicalknightx/",
            twitter: "https://twitter.com/magicalknightx",
            mentions: "2022 | VF1_Gimure"
        }
    }
}
</script>

<style scoped>
.footer-container {
    padding-top: 2rem;
    width: 100vw;
    color:white;
    background-color: #1A1A1A;
    display:flex;
    flex-direction:column;
    align-items:center;
    -webkit-box-shadow: 0 2px 2px 1px #C96F2D;
    -moz-box-shadow: 0 2px 2px 1px #C96F2D;
    box-shadow: 0 2px 2px 1px #C96F2D;
}
.content {
    display:flex;
    justify-content:space-around;
    align-items:center;
    width:100vw;
}
.logo {
    width:5rem;
}
.socials {
    width:20vw;
    display: flex;
    justify-content : space-between;
}
.socials p{
    padding-left: 1rem;
}
.socials a {
    text-decoration: none;
    color: white;
}
.socials a:checked {
    color: white;
}
.socials i {
    font-size: 2rem;
}
.mentions p {
    padding-top: 1rem;
    font-size: 0.7rem;
    align-items: center;
}
.mentions a {
    text-decoration: none;
    color: white;
}
.mentions a:hover {
    color:white;
}
.mentions a.selected {
    color:white;
}
@media only screen and (max-width: 500px) {
    .main-nav-list{
        flex-direction: column;
    }
    .socials {
        width: 30vw;
    }
    .socials i {
        font-size: 2rem;
    }
}
</style>
